import { helpers } 		from './webtero/helpers.js';
// import { example } 	from './webtero/components/exapmple.js';

window.webtero = {
	globals: {
		impMapName: 'Mapa',
	},

	init: function () {
		var self = this;

		self.activeDay();
		self.headerShops();

		self.headerShopToggleChange()
		self.headerShopToggle();

		// done
		jQuery( document ).on( 'click', '.squares-clear', function(){
			var index = jQuery( this ).closest( '[data-index]' ).attr( 'data-index' );
			var shapeName = jQuery( `.imp-shape[data-index="${index}"]` ).attr( 'data-shape-title' );

			jQuery.imageMapProHideTooltip( self.globals.impMapName, shapeName );
		});

		var urlData = window.location.href.split( '?location=' );

			jQuery.imageMapProInitialized = function(imageMapName) {
				self.globals.impMapName = imageMapName;
				
				if( urlData.length == 2 ) {

					var string = decodeURI( urlData[1] );
					// string = string.replaceAll( '%20', ' ' );

					jQuery( `[data-imp-highlight-shape-on-mouseover="${string}"]` ).click();
					jQuery.imageMapProOpenTooltip( imageMapName, string );
				}
			}
	},

	headerShopToggleChange() {
		if( jQuery( '.js-headerShops li.active').length ) {
			if( jQuery( '.js-headerShops li.active').next().length ) {
				jQuery( '.js-headerShops li.active').removeClass('active').next().addClass('active');
				return;
			}
		}
		jQuery( '.js-headerShops li.active').removeClass('active');
		jQuery( ".js-headerShops li" ).first().addClass('active');
	},

	headerShopToggle() {
		var self = this;
		setTimeout(function(){
			self.headerShopToggleChange()
			self.headerShopToggle();
		}, 2200);
	},


	fillHeaderShopInfo( $tr, name, data) {
		$tr.attr( 'data-closed', data.closed );
		$tr.attr( 'data-close', data.close );
		$tr.attr( 'data-open', data.open );

		let from = $tr.closest( 'ul' ).data( 'from');
		let to = $tr.closest( 'ul' ).data( 'to');

		$tr.append( name );

		if( !data.closed ) {
			$tr.append( ` ${from} ${data.open} ${to} ${data.close}` ); 
		}
	},

	headerShops() {
		var self = this;
		let days = ['sunday', 'monday', 'thuesday', 'wednesday', 'thursday', 'friday', 'saturday' ];
		let currentDateString = new Date().toISOString().slice(0, 10);
		let todayNumber =  new Date().getDay();

		jQuery( ".js-headerShops li" ).each(function( index ) {
			let shop = jQuery( this ).data( 'shop' );
			let tr = jQuery( this );
			
			let setted = false;

			jQuery.each(shop.changes, function(index, value) {
				if( shop.changes[index].date ==  currentDateString  ) {
					if( shop.changes[index].closed  ) { shop.changes[index].closed = 1;	}
					else { 	shop.changes[index].closed = 0; }

					self.fillHeaderShopInfo( jQuery(tr), shop.name, shop.changes[index] )
					self.checkTrDay( jQuery( tr ) );

					setted = true;
				}
			});

			if( ! setted ) {
				self.fillHeaderShopInfo( jQuery(this), shop.name, shop.opening_hours[days[todayNumber]] )
				self.checkTrDay( jQuery( this ) );
			}
		});
	},

	checkTrDay( $tr ) {
		let currentTime = new Date();

		let close_time = $tr.data('close');
		let open_time = $tr.data('open');
		let close = new Date().setHours( close_time.slice( 0, 2 ), close_time.slice( -2 ) );
		let open = new Date().setHours( open_time.slice( 0, 2 ), open_time.slice( -2 ) );

		if( $tr.data('closed') == 1 ) {
			$tr.find( '.js-openIndicator' ).addClass('active closed').text(  jQuery("[data-close-text]").data( 'close-text' ) ) ;
		}
		else if( currentTime.getTime() >= open && currentTime.getTime() < close) {
			$tr.find( '.js-openIndicator' ).addClass('active').text(  jQuery("[data-open-text]").data( 'open-text' ) ) ;
		}
		else {
			$tr.find( '.js-openIndicator' ).addClass('active closed').text(  jQuery("[data-close-text]").data( 'close-text' ) ) ;
		}
	},

	activeDay() {
		var self = this;

		let todayNumber =  new Date().getDay() - 1;

		jQuery( ".js-openingHours" ).each(function( index ) {
			let today_tr = jQuery( this ).find( 'tr' ).eq( todayNumber );
			today_tr.addClass('active-day');

			self.checkTrDay(today_tr);
		});

		let currentDateString = new Date().toISOString().slice(0, 10);;
		jQuery( ".js-changes tr[data-date='"+currentDateString+"']" ).each(function( index ) {
			jQuery( this ).closest( '.shops__one' ).find( '.js-openIndicator' ).removeClass( 'active' );
			jQuery( this ).closest( '.shops__one' ).find( '.active-day' ).removeClass( 'active-day' );

			jQuery( this ).addClass( 'active-day');

			self.checkTrDay( jQuery( this ) );
		});
	},

	onresize() {
		var self = this;
	},

	onscroll(position, previusPosition) {
		var self = this;
	},
};

jQuery(document).ready(function ($) {
	webtero.init();
});

window.addEventListener('scroll', function (e) {
	webtero.onscroll();
});

window.addEventListener('resize', function (e) {
	webtero.onresize();
});